import React from 'react';
import { Heading, Text } from '@/Components/ui/typography';
import { Stack } from '@/Components/ui/layout';

function CoverLetter() {
  return (
    <div className="flex mt-8 max-w-full w-[536px] flex-col">
      <Heading level="h2" size="lg" className="font-medium text-slate-900 leading-none m-0">
        COVER LETTER
      </Heading>
      <Stack spacing="sm" className="mt-6 w-full flex-col text-base text-slate-600 font-normal">
        <Text size="base" className="my-3 leading-6">
          Dear Sir,
        </Text>
        <Text size="base" className="my-3 leading-6 text-justify">
          I am writing to express my interest in the fourth grade instructional position that is currently available in the Fort Wayne Community School System. I learned of the opening through a notice posted on JobZone, IPFW's job database. I am confident that my academic background and curriculum development skills would be successfully utilized in this teaching position.
        </Text>
        <Text size="base" className="my-3 leading-6 text-justify">
          I have just completed my Bachelor of Science degree in Elementary Education and have successfully completed Praxis I and Praxis II. During my student teaching experience, I developed and initiated a three-week curriculum sequence on animal species and earth resources. This collaborative unit involved working with three other third grade teachers within my team, and culminated in a field trip to the Indianapolis Zoo Animal Research Unit.
        </Text>
        <Text size="base" className="my-3 leading-6">
          Sincerely,
        </Text>
        <Text size="base" className="my-3 leading-6">
          Esther Howard
        </Text>
      </Stack>
    </div>
  );
}

export default CoverLetter;